import { MARQUEE } from "@/data/article";

export const Marquee = () => {
  const items = [...MARQUEE, ...MARQUEE];
  return (
    <div
      data-testid="editorial-marquee"
      className="relative flex overflow-hidden border-y py-6 select-none"
      style={{ borderColor: "var(--line)", background: "var(--ink)", color: "var(--bg)" }}
    >
      <div className="flex shrink-0 animate-marquee whitespace-nowrap">
        {items.map((word, i) => (
          <span key={i} className="mx-8 inline-flex items-center gap-8">
            <span className="font-display text-2xl uppercase tracking-tight md:text-3xl">{word}</span>
            <span style={{ color: "var(--accent)" }} className="text-xl">✦</span>
          </span>
        ))}
      </div>
      <div className="flex shrink-0 animate-marquee whitespace-nowrap" aria-hidden="true">
        {items.map((word, i) => (
          <span key={i} className="mx-8 inline-flex items-center gap-8">
            <span className="font-display text-2xl uppercase tracking-tight md:text-3xl">{word}</span>
            <span style={{ color: "var(--accent)" }} className="text-xl">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};
